import { InputHTMLAttributes, ReactElement, useState } from "react";
import { ProfilePic, Cancel, Logo } from "../../assets";
import { AppBar, Drawer, Menu } from "@mui/material";
import HeaderResponsive from "./header_responsive";
import { Link, useNavigate } from "react-router-dom";
import Fade from '@mui/material/Fade';
import { CiMenuFries, CiWavePulse1 } from "react-icons/ci";
import { logout } from "../../core/service";
import { connect } from "react-redux";
import { Button } from "../components/button";
import routes from "../../core/routes";
import { IoMdNotificationsOutline } from "react-icons/io";
import {
  MdOutlineApps,
  MdMedicalServices,
  MdBusinessCenter,
  MdBusiness,
  MdOutlineOpenInNew,
} from "react-icons/md";

const quickAccessApps = [
  { name: "سامانه بیمه‌ای", url: "https://core.karamad.net/", icon: <MdMedicalServices /> },
  { name: "سامانه نمایندگان", url: "https://mlm.karamad.net/", icon: <MdBusinessCenter /> },
  { name: "سامانه شرکتی", url: "https://corp.karamad.net/", icon: <MdBusiness /> },
];

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  title: string;
  ticketList?: any;
  userData?: any;

}

export function Header({ title, ticketList , userData }: Props): ReactElement {
  const navigation = useNavigate();
  const [openMenu, setOpen] = useState(false);
  const [anchorElNotifications, setAnchorElNotifications] = useState<null | HTMLElement>(null);
  const openNotifications = Boolean(anchorElNotifications);
  const handleClickNotification = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNotifications(event.currentTarget);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorElQuickAccess, setAnchorElQuickAccess] = useState<null | HTMLElement>(null);
  const openQuickAccess = Boolean(anchorElQuickAccess);
  const handleClickQuickAccess = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElQuickAccess(event.currentTarget);
  };
  const handleCloseQuickAccess = () => {
    setAnchorElQuickAccess(null);
  };
  const handleCloseNotifications = (id?: string) => {
    setAnchorElNotifications(null);
    if (id) {
      // navigation(`/details-ticket/${id}`)


      window.location.href = `/details-ticket/${id}`
    }
  };
  const handleShowTicket = () => {

    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
      const updatedFilter = { ...filters, seen: "false" };
      sessionStorage.setItem('filters', JSON.stringify(updatedFilter))

      navigation(`${routes.TICKETING}`);
      window.location.reload();

  }
  return (
    <>
      <div className="hide-desktop">
        <Drawer anchor={"left"} open={openMenu} onClose={() => setOpen(false)}>
          <div className="header-drawer" onClick={() => setOpen(false)}>
            <div className="text-start">
              <Cancel color="#ffffff" />
            </div>
            <HeaderResponsive />
          </div>
        </Drawer>
      </div>

      <AppBar style={{ background: '#f5f6fa', paddingBottom: "10px", borderRadius: "10px 10px 0  0", boxShadow: "unset", height: "84px" }} position="sticky">
        <div className="header mt-2">

          <h2 className="title hide-mobile">
            {title}
          </h2>
          <div className="menu has-cursor hide-desktop" onClick={() => setOpen(true)}>
            <CiMenuFries color="#000000" size={20} />
          </div>

          <div className="content">

            <div
              id="fade-button-quick-access"
              className="quick-access-btn"
              aria-controls={openQuickAccess ? 'quick-access-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openQuickAccess ? 'true' : undefined}
              onClick={handleClickQuickAccess}
            >
              <MdOutlineApps size={26} color="#525151" className="cursor-pointer" />
            </div>
            <Menu
              id="quick-access-menu"
              className="quick-access-menu"
              MenuListProps={{
                'aria-labelledby': 'fade-button-quick-access',
              }}
              anchorEl={anchorElQuickAccess}
              open={openQuickAccess}
              onClose={handleCloseQuickAccess}
              TransitionComponent={Fade}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'left', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >
              <div className="quick-access-title">
                <MdOutlineApps />
                <span>دسترسی سریع</span>
              </div>
              {quickAccessApps?.map((app: any, index: number) => (
                <div
                  className="quick-access-item"
                  key={index}
                  onClick={() => {
                    window.open(app?.url, "_blank");
                    handleCloseQuickAccess();
                  }}
                >
                  <span className="quick-access-item-icon">{app?.icon}</span>
                  <span className="quick-access-item-name">{app?.name}</span>
                  <MdOutlineOpenInNew className="quick-access-item-external" />
                </div>
              ))}
            </Menu>


            <div
              id="fade-button"
              aria-controls={open ? 'fade-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <IoMdNotificationsOutline  size={30} color="#525151" className="cursor-pointer" />
            </div>
            <Menu
              className="notification-list"
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'left', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            >

              <div className="notification-head">
                <div className="notification-head-title">
                  <IoMdNotificationsOutline />
                  <span>اعلان‌ها</span>
                </div>
                {ticketList?.length > 0 && (
                  <span className="notification-head-count">
                    {ticketList.length.toLocaleString("fa-IR")}
                  </span>
                )}
              </div>

              <div className="notification-body">
                {ticketList?.slice(0, 5)?.map((item: any, index: number) => {
                  return (
                    <div
                      className="notification-item"
                      key={index}
                      onClick={() => handleCloseNotifications(item?.id)}
                    >
                      <span className="notification-item-icon">
                        <IoMdNotificationsOutline />
                      </span>
                      <div className="notification-item-content">
                        <div className="notification-item-subject">
                          {item?.subject || "—"}
                        </div>
                        <div className="notification-item-date">{item?.date}</div>
                      </div>
                    </div>
                  );
                })}
                {(!ticketList || ticketList.length === 0) && (
                  <div className="notification-empty">
                    <IoMdNotificationsOutline />
                    <span>اعلانی وجود ندارد</span>
                  </div>
                )}
              </div>

              <div className="notification-footer">
                <Button
                  myStyle="bg-blue w-100"
                  title="مشاهده همه اطلاعیه‌ها"
                  onClick={() => handleShowTicket()}
                />
              </div>
            </Menu>
            <div className="d-flex align-items-center ">
              <div
                id="fade-button-notification"
                aria-controls={openNotifications ? 'profile-options' : undefined}
                aria-haspopup="true"
                aria-expanded={openNotifications ? 'true' : undefined}
                onClick={handleClickNotification}
              >
                <img src={ProfilePic} alt="" className="profile-img" />
              </div>
              <Menu
                id="profile-options"
                className="profile-options"
                MenuListProps={{
                  'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorElNotifications}
                open={openNotifications}
                onClose={()=>handleCloseNotifications()}
                TransitionComponent={Fade}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}

                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              >
                <div className="item"> {userData?.first_name || "--"}  {userData?.last_name || "--"}</div>
                <hr />
                <div className="item" onClick={() => logout()}>خروج</div>
              </Menu>

            </div>
          </div>


        </div>
      </AppBar>
    </>
  )
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
    ticketList: dispatch.ticket.ticketList
  };
};
export default connect(mapStateToProps)(Header);
